import {
  createCard,
  type CreateCardParams,
} from 'api/v2/connectors/createCard';
import { useMutation } from 'react-query';
import { createRelativeURLFromOrigin } from 'utils/helpers';

const useCreateCard = () => {
  return useMutation(
    (params?: Partial<CreateCardParams>) =>
      createCard({
        successRedirectUri:
          params?.successRedirectUri || createRelativeURLFromOrigin(),
        errorRedirectUri:
          params?.errorRedirectUri || createRelativeURLFromOrigin(),
        type: params?.type || 'virtual',
        design: params?.design || 'standard',
        ...params,
      }),
    {
      onSuccess: ({ redirectUri }) => {
        window.location.href = redirectUri;
      },
    },
  );
};

export default useCreateCard;
